import cx from 'classnames';
import {
    PHONE_VERIFICATION_PAGE_A1_AFTER,
    PHONE_VERIFICATION_PAGE_A1_BEFORE_btn,
    PHONE_VERIFICATION_PAGE_A1_BEFORE_BTN,
    PHONE_VERIFICATION_PAGE_A2a,
    PHONE_VERIFICATION_PAGE_A2b,
    PHONE_VERIFICATION_PAGE_A3,
    PHONE_VERIFICATION_PAGE_A4_AFTER,
    PHONE_VERIFICATION_PAGE_A4_BEFORE,
    PHONE_VERIFICATION_PAGE_BUTTON,
    PHONE_VERIFICATION_PAGE_Q1,
    PHONE_VERIFICATION_PAGE_Q2,
    PHONE_VERIFICATION_PAGE_Q3,
    PHONE_VERIFICATION_PAGE_Q4,
} from 'mk/autogenerated/translations/ManualPhoneVerification.d6071316c9d44de788bb25eb9f3a9298'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { Props } from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerificationPage';
import { loginUrl, usersManualPhoneVerificationUrl } from 'mk2/apps/users/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import ImgResponsive from 'mk2/components/ImgResponsive';
import Interpolate from 'mk2/components/Interpolate';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './ManualPhoneVerification.mscss';

export default class ManualPhoneVerification extends React.Component<Props> {

    public render() {
        const { alreadyVerified, loadingState } = this.props;

        return (
            <div className={styles.ManualPhoneVerification}>
                <ImgResponsive
                    imgUrl={`${assetUrl}img/phone/phone-verification-header-v4-${ACTIVE_SERVER_ID}.png`}
                    width={980}
                    height={215}
                />

                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={alreadyVerified != null}
                />
            </div>
        );
    }

    private load = () => {
        const { onLoad, requestUser } = this.props;

        if (isAuthenticated(requestUser)) {
            onLoad(requestUser.id);
        }
    };

    private renderLoadSuccess = () => {
        const { alreadyVerified, onOpenVerifyModal, requestUser } = this.props;

        return (
            <div className={styles.ManualPhoneVerification__content}>
                <div className={styles.ManualPhoneVerification__header}>{PHONE_VERIFICATION_PAGE_Q1}</div>
                {isAuthenticated(requestUser) && alreadyVerified
                    ? <div className={styles.ManualPhoneVerification__answer}>{PHONE_VERIFICATION_PAGE_A1_AFTER}</div>
                    : (
                        <div className={styles.ManualPhoneVerification__answer}>
                            <Interpolate
                                i18nKey={PHONE_VERIFICATION_PAGE_A1_BEFORE_btn}
                                btn={isAuthenticated(requestUser)
                                    ? (
                                        <a onClick={onOpenVerifyModal}>
                                            {PHONE_VERIFICATION_PAGE_A1_BEFORE_BTN}
                                        </a>
                                    ) : (
                                        <a href={url(loginUrl, {},  {next: usersManualPhoneVerificationUrl})}>
                                            {PHONE_VERIFICATION_PAGE_A1_BEFORE_BTN}
                                        </a>
                                    )
                                }
                            />
                        </div>
                    )
                }

                <div className={styles.ManualPhoneVerification__header}>{PHONE_VERIFICATION_PAGE_Q2}</div>
                <div className={styles.ManualPhoneVerification__answer}>
                    <ul className={styles.ManualPhoneVerification__benefitsList}>
                        <li className={styles.ManualPhoneVerification__benefitsItem}>
                            {PHONE_VERIFICATION_PAGE_A2a}
                        </li>
                        <li
                            className={cx(
                                styles.ManualPhoneVerification__benefitsItem,
                                styles['ManualPhoneVerification__benefitsItem--last'],
                            )}
                        >
                            {PHONE_VERIFICATION_PAGE_A2b}
                        </li>
                    </ul>
                </div>

                <div className={styles.ManualPhoneVerification__header}>{PHONE_VERIFICATION_PAGE_Q3}</div>
                <div className={styles.ManualPhoneVerification__answer}>{PHONE_VERIFICATION_PAGE_A3}</div>

                <div className={styles.ManualPhoneVerification__header}>{PHONE_VERIFICATION_PAGE_Q4}</div>
                <div className={styles.ManualPhoneVerification__answer}>
                    {alreadyVerified ? (
                        <div>
                            <i className={cx(styles.ManualPhoneVerification__checkIcon, 'fa fa-check')} />
                            {PHONE_VERIFICATION_PAGE_A4_AFTER}
                        </div>
                    ) : (
                        <div>
                            {PHONE_VERIFICATION_PAGE_A4_BEFORE}
                        </div>
                    )}
                </div>

                {!isAuthenticated(requestUser) && (
                    <Btn
                        type={BtnType.BzGreen}
                        label={PHONE_VERIFICATION_PAGE_BUTTON}
                        link={url(loginUrl, {},  {next: usersManualPhoneVerificationUrl})}
                        asAnchor
                    />
                )}
                {isAuthenticated(requestUser) && !alreadyVerified && (
                    <Btn
                        type={BtnType.BzGreen}
                        label={PHONE_VERIFICATION_PAGE_BUTTON}
                        onClick={onOpenVerifyModal}
                    />
                )}
            </div>
        );
    };

}
